import { createFileRoute } from '@tanstack/react-router'
import QuoteEditPage from '@/pages/quote/quote-edit-page'
import z from 'zod'

const quoteSearchSchema = z.object({
  interventionId: z.uuid().optional(),
})

export type QuoteNewSearch = z.infer<typeof quoteSearchSchema>

export const Route = createFileRoute('/_quote-flow/org/$orgId/quotes/$quoteId')(
  {
    component: QuoteEditPage,
    validateSearch: quoteSearchSchema,
  }
)
